import { LoadingButton } from '@mui/lab';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from '@mui/material';
import React from 'react';

const ProductEditDialog = ({
  open,
  onClose,
  loading,
  canEditPack,
  qty,
  onQtyChange,
  packOptions,
  onSave,
  onSavePack,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    fullWidth
    maxWidth="xs"
    sx={{ direction: 'rtl' }}
  >
    <DialogTitle>{canEditPack ? 'تغییر بسته' : 'ویرایش تعداد'}</DialogTitle>
    <DialogContent>
      {canEditPack ? (
        <Stack gap={1} pt={1}>
          {packOptions.map(pack => (
            <Button
              key={pack.guid}
              variant="outlined"
              onClick={() => onSavePack(pack)}
            >
              {pack.display || pack.name}
            </Button>
          ))}
        </Stack>
      ) : (
        <TextField
          fullWidth
          sx={{ mt: 1 }}
          label="تعداد"
          type="number"
          value={qty}
          onChange={e => onQtyChange(e.target.value)}
        />
      )}
    </DialogContent>
    {!canEditPack ? (
      <DialogActions sx={{ gap: 1, p: 2 }}>
        <Button onClick={onClose}>انصراف</Button>
        <LoadingButton loading={loading} variant="contained" onClick={onSave}>
          ذخیره
        </LoadingButton>
      </DialogActions>
    ) : null}
  </Dialog>
);

export default ProductEditDialog;
